import React from 'react';
import AudioPlayer from './AudioPlayer';
import Announcements from './Announcements';

const Hero = () => {
  return (
    <section id="home" className="min-h-screen flex items-center justify-center temple-gradient pt-20">
      <div className="container mx-auto px-4 text-center">
        <div className="max-w-4xl mx-auto">
          {/* Temple Name */}
          <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-8 shadow-temple lotus-border mb-8">
            <h1 className="text-3xl md:text-5xl font-bold text-saffron mb-4">
              SREE KRISHNASWAMY DEVASWOM
            </h1>
            <h2 className="text-xl md:text-2xl font-semibold text-gray-800 mb-6">
              KODUNGALLUR
            </h2>
            
            {/* Hero Image */}
            <div className="mb-6">
              <img
                src="https://customer-assets-m6fa6gv7.emergentagent.net/job_6b23d131-7c65-4566-a2b5-504887f6a0cf/artifacts/rahn50gk_%E0%A5%A4%E0%A5%A4%E0%A5%90%20%E0%A4%B6%E0%A5%8D%E0%A4%B0%E0%A5%80%20%E0%A4%B0%E0%A4%BE%E0%A4%9C%E0%A4%97%E0%A5%8B%E0%A4%AA%E0%A4%BE%E0%A4%B2%20%E0%A4%95%E0%A5%83%E0%A4%B7%E0%A5%8D%E0%A4%A3%E0%A4%BE%E0%A4%AF%20%E0%A4%A8%E0%A4%AE%E0%A4%83%E0%A5%A4%E0%A5%A4%20%E0%A5%A4%E0%A5%A4%20%E0%A5%90%20%E0%A4%A8%E0%A4%AE%E0%A5%8B%20%E0%A4%AD%E0%A4%97%E0%A4%B5%E0%A4%A4%E0%A5%87%20%E0%A4%B5%E0%A4%BE%E0%A4%B8%E0%A5%81%E0%A4%A6%E0%A5%87%E0%A4%B5%E0%A4%BE%E0%A4%AF%E0%A5%A4%E0%A5%A4_20260722_202126_0000%20%281%29.png"
                alt="Sree Rajagopala Krishnaswamy Temple Deity"
                className="mx-auto w-full max-w-2xl h-auto rounded-lg shadow-temple lotus-border"
                style={{objectFit: 'contain'}}
              />
            </div>

            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              A tale woven from faith, migration, and profound personal devotion rests on the ancient soil of <strong>Kodungallur</strong>, 
              a port once bustling with the whispers of the sea and the clamor of trade.
            </p>
            
            {/* Call to Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <button
                onClick={() => document.getElementById('history')?.scrollIntoView({ behavior: 'smooth' })}
                className="bg-gold text-saffron border-2 border-saffron px-8 py-3 rounded-full font-semibold hover:bg-saffron hover:text-gold transition-all duration-300"
                data-testid="learn-more-btn"
              >
                History
              </button>
              <button
                onClick={() => {
                  window.open("https://maps.app.goo.gl/CvwtNGgq9qstkDrp7?g_st=am", '_blank');
                }}
                className="bg-saffron text-gold border-2 border-saffron px-8 py-3 rounded-full font-semibold hover:bg-gold hover:text-saffron transition-all duration-300"
                data-testid="directions-btn"
              >
                Directions to reach
              </button>
              <button
                onClick={() => {
                  window.open("https://youtu.be/OUAXGXCFxCg?si=0TF3pMjvEom0_kY-", '_blank');
                }}
                className="bg-gold text-saffron border-2 border-saffron px-8 py-3 rounded-full font-semibold hover:bg-saffron hover:text-gold transition-all duration-300"
                data-testid="temple-video-btn"
              >
                Temple Video
              </button>
            </div>
            
            {/* Audio Player */}
            <div className="mt-6">
              <AudioPlayer
                title="Mantra Chant"
                src="https://customer-assets.emergentagent.com/job_devaswom-preview/artifacts/gcmrl6ka_mantra.mp3.MP3"
              />
            </div>
            
            {/* Image after Mantra Chant */}
            <div className="mt-6">
              <img
                src="https://customer-assets.emergentagent.com/job_devaswom-preview/artifacts/t6kvlgu7_IMG_20260222_194847.jpg"
                alt="Temple image"
                className="mx-auto max-w-full h-auto rounded-lg shadow-temple lotus-border"
              />
            </div>
          </div>

          {/* Website Launch Information */}
          <div className="mt-8 mb-6">
            <div className="bg-gradient-to-r from-orange-100 to-yellow-100 border border-saffron rounded-lg p-4 shadow-md">
              <p className="text-base md:text-lg text-gray-700 font-medium text-center">
                Website launched on <strong>October 17, 2025</strong> (Kanni 31, Makam star, Kollavarsham 1201) by Devaswom Thantri, <strong className="text-saffron">Brahmashree Vinod Bhat</strong>
              </p>
            </div>
          </div>

          {/* Latest Announcements */}
          <Announcements announcements={[
            "The Vazhipadu/Sevas section has been updated as of 17th August 2026, the seva amounts may change as per the material costs. Kindly confirm the rates with the management in the future.",
            "Deepavali - 8/11/2026 - Sevas - Avil (flattened rice) Naivedyam (Rs 120/-), Tailabhishekam (Rs 220/-), Tulasi Aarathi - 6:15 AM"
          ]} />

          {/* Image between notifications and sacred legacy */}
          <div className="mt-8 mb-6">
            <img
              src="https://customer-assets.emergentagent.com/job_devaswom-preview/artifacts/by2rmyfk_IMG_20260224_205833.jpg"
              alt="Temple deity image"
              className="mx-auto max-w-full h-auto rounded-lg shadow-temple lotus-border"
            />
          </div>

          {/* Sacred Legacy Quote */}
          <div className="bg-gradient-to-r from-saffron to-gold text-white rounded-xl p-6 shadow-temple">
            <h3 className="text-xl font-bold mb-4">
              The Sacred Legacy of Sree Krishnaswamy Temple
            </h3>
            <p className="text-base opacity-90 mb-4">
              The history of Sree Krishnaswamy temple stands as a distinctive chapter 
              in the annals of the Gowda Saraswat Brahmins (GSBs).
            </p>
            <div className="mt-4">
              <img
                src="https://customer-assets.emergentagent.com/job_devaswom-preview/artifacts/tu9myu2r_IMG_20260224_205706.jpg"
                alt="Temple historical image"
                className="mx-auto max-w-full h-auto rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
